import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import UserList from "./UserList.jsx";
import AddUserToResourcePanel from "./AddUserToResourcePanel.jsx";

import { OPERATIONS } from "../../constants/operations.js";
import { USERS } from "../../state/actions/actionConstants.js";

import {
  createResourceInviteByExistingUser,
  createResourceInviteByEmail
} from "../../state/reducers/users/userActions.js";
import { selectOperationAvailability } from "../../state/reducers/operations/operationSelector.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class UserPanel extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    disabled: PropTypes.bool.isRequired,
    createResourceInviteByExistingUser: PropTypes.func.isRequired,
    createResourceInviteByEmail: PropTypes.func.isRequired,
    createInviteeAvailability: PropTypes.object.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "users.user_panel",
    disabled: false
  };

  // -- HANDLERS -- //

  onSubmit = values => {
    const {
      createResourceInviteByExistingUser,
      createResourceInviteByEmail,
      data
    } = this.props;

    if (values && values.user) {
      createResourceInviteByExistingUser(
        data["@id"],
        data["@type"],
        values.user,
        values.sudo
      );
    } else {
      createResourceInviteByEmail(
        data["@id"],
        data["@type"],
        values.email,
        values.projectGroup,
        values.sudo
      );
    }
  };

  // -- RENDER -- //

  getMessageData = () => {
    const { data, copyKey, copy } = this.props;

    const requestActionType = get(data, "requestAction.type", null);

    switch (requestActionType) {
      case USERS.POST:
        return {
          title: copy(`${copyKey}.add_success.title`),
          message: copy(`${copyKey}.add_success.message`),
          positive: true,
          negative: false
        };

      case USERS.DELETE:
        return {
          title: copy(`${copyKey}.delete_success.title`),
          message: copy(`${copyKey}.delete_success.message`),
          positive: false,
          negative: true
        };
      default:
        return null;
    }
  };

  renderMessage = () => {
    const messageData = this.getMessageData();

    if (messageData) {
      return (
        <SegmentMessage
          title={messageData.title}
          message={messageData.message}
          dismissable={true}
          positive={messageData.positive}
          negative={messageData.negative}
        />
      );
    }

    return null;
  };

  render() {
    const {
      data,
      createInviteeAvailability: { permitted, enabled },
      disabled,
      copyKey,
      copy
    } = this.props;

    // bail early if no user data of any kind is available
    if (!data) {
      return (
        <Segment disabled={disabled}>
          <Header as="h3">{copy(`${copyKey}.title`)}</Header>
          <p>{copy(`${copyKey}.unavailable`)}</p>
        </Segment>
      );
    }

    // as we have data a missing users property indicates a permissions issue
    if (!data.hasOwnProperty("users")) return null;

    return (
      <Segment disabled={disabled}>
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        {this.renderMessage()}
        <UserList entity={data} disabled={disabled} />

        {!disabled && permitted && enabled && (
          <AddUserToResourcePanel data={data} onSubmit={this.onSubmit} />
        )}
      </Segment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  createInviteeAvailability: selectOperationAvailability(
    state,
    props,
    OPERATIONS.ADD_USER
  ),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  createResourceInviteByExistingUser: (...args) =>
    dispatch(createResourceInviteByExistingUser(...args)),
  createResourceInviteByEmail: (...args) =>
    dispatch(createResourceInviteByEmail(...args))
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPanel);

// -- MAY BE USEFUL FOR TESTING LATER -- //

// const TEST_ROLES = [
//   {
//     "@id": "/groups/abc",
//     "@type": "Role",
//     id: "abc",
//     path: "org1.c5199248-ae1f-11e9-a767-0800275f82b1.abc",
//     name: "administrator",
//     permissions: [
//       {
//         "@id": "",
//         "@type": "Permission",
//         id: "",
//         name: "start resource"
//       },
//       {
//         "@id": "",
//         "@type": "Permission",
//         id: "",
//         name: "start resource"
//       }
//     ]
//   },
//   {
//     "@id": "/groups/abc",
//     "@type": "Role",
//     id: "def",
//     path: "org1.c5199248-ae1f-11e9-a767-0800275f82b1.abc",
//     name: "editor",
//     permissions: [
//       {
//         "@id": "",
//         "@type": "Permission",
//         id: "",
//         name: "start resource"
//       },
//       {
//         "@id": "",
//         "@type": "Permission",
//         id: "",
//         name: "start resource"
//       }
//     ]
//   },
//   {
//     "@id": "/groups/abc",
//     "@type": "Group",
//     id: "ghi",
//     path: "org1.c5199248-ae1f-11e9-a767-0800275f82b1.abc",
//     name: "artist",
//     permissions: [
//       {
//         "@id": "",
//         "@type": "Permission",
//         id: "",
//         name: "start resource"
//       },
//       {
//         "@id": "",
//         "@type": "Permission",
//         id: "",
//         name: "start resource"
//       }
//     ]
//   }
// ];
